/**
 * YouTube Live Detection Constants
 */

/** YouTube Data API v3 base URL */
export const YOUTUBE_API_BASE_URL = "https://www.googleapis.com/youtube/v3";

/** YouTube watch URL prefix */
export const YOUTUBE_WATCH_URL = "https://www.youtube.com/watch?v=";

/** Cache TTL when channel IS live (30 seconds) */
export const CACHE_TTL_LIVE = 300;

/** Cache TTL when channel is NOT live (20 minutes) */
export const CACHE_TTL_NOT_LIVE = 1200;

/** Default polling interval for the hook (5 minutes) */
export const DEFAULT_POLLING_INTERVAL = 300_000;

/** Default API endpoint for the hook */
export const DEFAULT_API_ENDPOINT = "/api/youtube/live";

/** Default channel ID (Jesus Central Church) */
export const DEFAULT_CHANNEL_ID = "UCF1mKf9r3VLq7Y9LHe3PMHA";
